import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { useSelector } from 'react-redux';
import { NamespacedStoreState } from '@Types/store.types';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const utilStoreSelector = createSelector(parseNamespace, state => state.util);

export const selectAssetBackLabelSelector = createSelector(utilStoreSelector, utilState => utilState.assetBackLabel);

export const selectAssetBackLabel = () => useSelector(selectAssetBackLabelSelector);
